export default "__VITE_ASSET__CDAEhUFZ__"